// @module Katoomi.Shiphawk.Review
define('Katoomi.Shiphawk.Review.View'
    , [
        'katoomi_shiphawk_review.tpl'
        , 'Wizard.Module'
        , 'Profile.Model'
        , 'Utils'
        , 'jQuery'
        , 'GlobalViews.Message.View'
        , 'Katoomi.Shiphawk.Address.View'
        , 'Katoomi.Shiphawk.CartItemsShip.View'
        , 'underscore'
        , 'Backbone.CompositeView'
    ]
    , function (
        katoomi_shiphawk_review_tpl
        , WizardModule
        , ProfileModel
        , Utils
        , jQuery
        , GlobalViewsMessageView
        , AddressView
        , CartItemsShipView
        , _
        , BackboneCompositeView
    ) {
        'use strict';

        // @class Katoomi.Shiphawk.Review.View @extends Backbone.View
        return WizardModule.extend({

            template: katoomi_shiphawk_review_tpl

            // @property {Array} errors
            , errors: ['ERR_NOT_SET_SHIPPING_METHODS', 'ERR_NOT_SET_SHIPPING_ADDRESS', 'ERR_CHK_SELECT_SHIPPING_METHOD']

            , shipMethodIsRequire: {
                errorMessage: Utils.translate('Please select a delivery method'),
                errorCode: 'ERR_NOT_SET_SHIPPING_METHODS'
            }

            , shipAddressIsRequire: {
                errorMessage: Utils.translate('Please select a shipping address'),
                errorCode: 'ERR_NOT_SET_SHIPPING_ADDRESS'
            }

            //events to handle when the user changes the delivery option 
            , events: {
                'change [data-action="select-delivery-option"]': 'changeDeliveryOptions'
            }

            //shippingMethods are cached so don't have to query server multiple times
            , shippingMethodsCache: {}


            , initialize: function () {
                var self = this;
                WizardModule.prototype.initialize.apply(this, arguments);

                //waitShipmethod is a boolean that waits to see if the ship method have been loaded
                this.waitShipmethod = SC.ENVIRONMENT.CART
                    ? !SC.ENVIRONMENT.CART.shipmethod
                    : !(this.shiphawk && this.wizard.model);

                //get the profile model and the addresses for this user
                this.profileModel = ProfileModel.getInstance();
                this.addresses = this.profileModel.get('addresses');


                BackboneCompositeView.add(this);

                //the wizard ismultishiptoUpdated bind the render function to this object
                this.wizard.model.on('ismultishiptoUpdated', _.bind(this.render, this));
                this.wizard.model.on('promocodeUpdated', this.render, this);
                this.wizard.model.on('change', this.render, this);

            }

            , destroy: function destroy() {
                this.address && this.address.off('change', this.render, this);
                return this._destroy();
            }

            , isActive: function isActive() {
                return !this.wizard.model.get('ismultishipto') && this.wizard.model.getIfThereAreDeliverableItems();
            }

            // @method present
            , present: function () {
                this.currentAddress = this.previousAddress = this.wizard.model.get('shipaddress');
                this.eventHandlersOn();
            }
            // @method future
            , future: function () {
                this.currentAddress = this.previousAddress = this.wizard.model.get('shipaddress');
                this.eventHandlersOn();
            }
            // @method past
            , past: function () {
                this.waitShipmethod = !this.wizard.model.get('custbody_shiphawk_rate');
                this.currentAddress = this.previousAddress = this.wizard.model.get('shipaddress');
                this.eventHandlersOn();
            }

            // @method eventHandlersOn
            , eventHandlersOn: function () {

                // Removes any leftover observer
                this.eventHandlersOff();

                //setup another event listener so that it defers the render function until other execution as finished. basically makes it called after things are done
                this.wizard.model.on('change:shipmethods', function () { _.defer(_.bind(this.render, this)); }, this);

            }

            // @method eventHandlersOff
            , eventHandlersOff: function () {
                // removes observers
                this.wizard.model.off('change:shipmethods', null, this);

            }


            // @method render
            , render: function () {

                if (this.state === 'present') {
                    if (this.wizard.model.get('custbody_shiphawk_rate') && !this.waitShipmethod) {
                        this.trigger('ready', true);
                    }
                    this._render();
                }
            }


            // @method submit
            , submit: function submit() {
                return this.isValid();
            }

            // @method isValid
            , isValid: function isValid() {

                var valid_promise = jQuery.Deferred();
 
				var options = this.wizard.model.get('options');
				var custbody_shiphawk_rate = options['custbody_shiphawk_rate'];
				var custbody_shiphawk_cart_rates = options['custbody_shiphawk_cart_rates'] ? JSON.parse(options['custbody_shiphawk_cart_rates']) : [];


                if (this.wizard.model.shippingAddressIsRequired()) {
                    if (!this.wizard.model.get('shipmethod')) {
                        return valid_promise.reject(this.shipMethodIsRequire);
                    }
                    if (!this.wizard.model.get('shipaddress')) {
                        return valid_promise.reject(this.shipAddressIsRequire);
                    }
                }

                if (custbody_shiphawk_rate && custbody_shiphawk_cart_rates && custbody_shiphawk_cart_rates.length > 0) {
                    valid_promise.resolve();
                } else {
                    valid_promise.reject({
                        errorCode: 'ERR_CHK_SELECT_SHIPPING_METHOD',
                        errorMessage: Utils.translate('Please select a delivery method')
                    });
                }


                return valid_promise;
            }

            // @method changeDeliveryOptions
            , changeDeliveryOptions: function changeDeliveryOptions(e) {
                var self = this;
                var target = jQuery(e.currentTarget);
                var targetValue = target.val() || target.attr('data-value');

                this.waitShipmethod = true;
                var options = this.wizard.model.get('options');
                var custbody_shiphawk_cart_rates = JSON.parse(options['custbody_shiphawk_cart_rates']);
                var rate = custbody_shiphawk_cart_rates.find(function (model) { return model.id === targetValue; });


                options['custbody_shiphawk_rate'] = rate.id;

                this.wizard.model.set('options', options);
                this.step.disableNavButtons();
                this.wizard.model.save().always(function () {
                    self.clearError();
                    self.step.enableNavButtons();
                });

            }

            // @method showError render the error message
            , showError: function showError() {
                var global_view_message = new GlobalViewsMessageView({
                    message: this.error.errorMessage,
                    type: 'error',
                    closable: true
                });

                // Note: in special situations (like in payment-selector),
                // there are modules inside modules, so we have several place holders,
                // so we only want to show the error in the first place holder.
                this.$('[data-type="alert-placeholder-module"]:first').html(
                    global_view_message.render().$el.html()
                );

                this.error = null;
            }

            , childViews: {
                'Shipping.Address': function () {
                    return new AddressView({
                        hideActions: !!this.options.hide_edit_address_button,
                        hideDefaults: true,
                        hideRemoveButton: true,
                        manage: 'shipaddress',
                        model: this.addresses.get(this.wizard.model.get('shipaddress')),
                        hideSelector: true
                    });
                },
                'Items.Collection': function() {
                    return new CartItemsShipView({
                        wizard: this.wizard,
                        exclude_on_skip_step: true,
                        hide_address: true,
                        show_opened_accordion: Utils.isDesktopDevice(),
                        is_accordion_primary: true,
                        show_edit_cart_button: !this.options.hide_edit_cart_button,
                        show_headers: false,
                        show_mobile: true
                    });
                }                
            }

            //@method getContext @return Katoomi.Shiphawk.Checkout.View.Context
            //@method getContext @return Katoomi.KatoomiShiphawkConnector.KatoomiShiphawkModule.View.Context
            , getContext: function getContext() {
                //@class Katoomi.KatoomiShiphawkConnector.KatoomiShiphawkModule.View.Context
                var self = this;

                var options = this.wizard.model.get('options');
                var custbody_shiphawk_rate = options['custbody_shiphawk_rate'];
                var custbody_shiphawk_cart_rates = JSON.parse(options['custbody_shiphawk_cart_rates']);

                var shipping_methods = custbody_shiphawk_cart_rates.map(function (shipmethod) {
                    return {
                        carrier: shipmethod.carrier,
                        carrier_details: shipmethod.carrier_details,
                        carrier_account: shipmethod.carrier_account,
                        carrier_code: shipmethod.carrier_code,
                        carrier_validated_destination_location_type: shipmethod.carrier_validated_destination_location_type,
                        currency_code: shipmethod.currency_code,
                        destination_network_location_id: shipmethod.destination_network_location_id,
                        est_delivery_date: shipmethod.est_delivery_date,
                        est_delivery_time: shipmethod.est_delivery_time,
                        id: shipmethod.id,
                        origin_network_location_id: shipmethod.origin_network_location_id,
                        price: shipmethod.price,
                        rate_display_name: shipmethod.rate_display_name,
                        rates_provider: shipmethod.rates_provider,
                        rates_provider_code: shipmethod.rates_provider_code,
                        rates_provider_type: shipmethod.rates_provider_type,
                        service_days: shipmethod.service_days,
                        service_level: shipmethod.service_level,
                        service_name: shipmethod.service_name,
                        standardized_service_name: shipmethod.standardized_service_name,
                        tariff_insurance_rule: shipmethod.tariff_insurance_rule,
                        isActive: shipmethod.id === custbody_shiphawk_rate
                    };
                });

                var address_source = this.addresses.get(this.wizard.model.get('shipaddress'));

                // @class OrderWizard.Module.Shipmethod.Context
                return {
                    // @property {LiveOrder.Model} model
                    model: this.wizard.model,
                    // @property {Boolean} showLoadingMethods
                    showLoadingMethods: this.reloadingMethods,

                    showShippingInformation: !!this.wizard.model.shippingAddressIsRequired(),
                    showShippingAddress: !!address_source,
                    editUrl: this.options.edit_url,
                    showEditButton: !!this.options.edit_url,
                    // @property {Boolean} hasShippingMethods
                    hasShippingMethods: !!shipping_methods.length,
                    // @property {Boolean} display select instead of radio buttons
                    showSelectForShippingMethod: shipping_methods.length > 0,
                    // @property {Array} shippingMethods
                    shippingMethods: shipping_methods,
                    // @property {Boolean} showTitle
                    showTitle: !this.options.hide_title,
                    // @property {Straing} title
                    showShippingMetod: !this.options.hideShippingMethod,
                    title: this.options.title || Utils.translate('Delivery Method'),
                    shippingAddress: !!address_source && address_source.get('fullname')
                };

            }


        });
    });
